<div class="content">
    <div class="content_text">{{params.value}}</div>
    <div class="content_link" (click)="openLink()">
        <i class="fal fa-external-link-square-alt"></i>
    </div>
</div>

